<template>
  <div>
    <Menu/>
    <section>
      <div class="container-fluid" v-if="!loading">

        <div class="row justify-content-center">
          <div class="col-lg-7 text-center mb-3">
            <h1 class="mb-3">THE SIGNATURE FARMS COLLECTION</h1>
            <p>
              This exclusive collection showcases some of South Africa’s most exceptional farms and luxury countryside retreats.
              Discover expansive working farms, refined country estates, private vineyard hideaways and bespoke rural sanctuaries.
              From rolling pastures and mountain backdrops to masterfully crafted homesteads, this portfolio captures the essence
              of refined farm living.
            </p>
          </div>
        </div>

        <div class="row justify-content-center">

          <div v-if="listings.length === 0">
            <h2 class="pt-5 text-center">No properties found</h2>
          </div>

          <div id="top"></div>

          <div
            class="col-lg-4 col-md-6 mt-3 mb-4 pb-4"
            v-for="(item, index) in listings"
            :key="index"
          >
            <div class="banner-section lifestyle-block switch-bg-lgrey p-3 h-100 bord-radius">

              <div class="portfolio-thumbnail">
                <a :href="'/commercial/' + item.payload.listing.data.listing[0].id">
                  <img
                    :src="item.payload.listing.data.listing[0].featured_image"
                    class="w-100 force-height"
                  >
                </a>

                <div
                  class="thumbnail-priceTag"
                  v-if="item.payload.listing.data.listing[0].poa != true"
                >
                  {{ formatCurrency(item.payload.listing.data.listing[0].price) }}
                </div>

                <div
                  class="thumbnail-priceTag"
                  v-if="item.payload.listing.data.listing[0].poa == true"
                >
                  POA
                </div>

                <div class="portfolio-type">
                  <div
                    class="typeOne mx-1"
                    v-for="(tag, propertyName) in item.payload.listing.tags"
                    v-if="tag == true"
                    :key="propertyName"
                  >
                    {{ propertyName }}
                  </div>
                </div>
              </div>

              <a
                :href="'/commercial/' + item.payload.listing.data.listing[0].id"
                class="text-decoration-none text-reset d-block"
              >
                <h4 class="text-start">
                  <span>
                    {{ item.payload.listing.data.listing[0].loc_suburb }},
                    {{ item.payload.listing.data.listing[0].loc_region }}
                  </span>
                  {{ item.payload.listing.data.listing[0].marketing_heading }}
                </h4>
              </a>

            </div>
          </div>

        </div>

      </div>

      <div v-else>
        <center><div class="spinner"></div></center>
        <h2>Loading luxury farms</h2>
      </div>

    </section>
    <Footer/>
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  components: { Menu, Footer },

  data() {
    return {
      listings: [],
      loading: true
    }
  },

  mounted() {
    this.fetchListings();
  },

  methods: {
    async fetchListings() {
  this.loading = true;

  try {
    const response = await axios.get(
      this.$store.state.apiBaseUrl + 'fetch_commercials.php',
      { headers: { Accept: 'application/json' } }
    );

    const rows = Array.isArray(response.data) ? response.data : [];

        this.listings = rows.filter((row) => {
          return row &&
            row.payload &&
            row.payload.listing &&
            row.payload.listing.data &&
            Array.isArray(row.payload.listing.data.listing) &&
            row.payload.listing.data.listing.length > 0;
        });

      } catch (error) {
        console.log(error);
        this.listings = [];
      }

      this.loading = false;
    }
  }
}
</script>

<style scoped>
.force-height {
  height: 300px;
  object-fit: cover;
}

.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-left: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>